import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

const isGooglePartner = (partners?: Array<PartnerFragment> | null) => {
  return !!partners?.find((partner) => partner?.name?.toLowerCase().includes('google'));
};

export default isGooglePartner;
